import React from "react";
import { Link } from "react-router-dom";

class Navbar extends React.Component {
  constructor() {
    super();

    this.state = {
      nav: false
    };
  }

  toggle = () => {
    this.setState({
      nav: !this.state.nav
    });
  };

  render() {
    return (
      <header className="bs-docs-nav navbar navbar-fixed-top" id="top">
        <div className="container">
          <div className="navbar-header">
            <button
              aria-controls="bs-navbar"
              aria-expanded="false"
              className="collapsed navbar-toggle"
              data-target="#bs-navbar"
              data-toggle="collapse"
              type="button"
              onClick={this.toggle}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <Link className="navbar-brand" to="/">
              <img
                height={15}
                src={`${process.env.PUBLIC_URL}/images/thelius-logo-white.png`}
                alt="Thelius logo white"
              />
            </Link>
          </div>
          <nav
            className={`collapse navbar-collapse ${this.state.nav ? "in" : ""}`}
            id="bs-navbar"
          >
            <ul className="nav navbar-nav navbar-right">
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    );
  }
}

export default Navbar;
